import React, { useMemo } from 'react';
import Modal from 'containers/Modal/Modal';
import { clearModal } from 'actions/modals/';
import { ASSET_MODAL } from 'constants/modal';
import { useDispatch, useSelector } from 'react-redux';
import { createAsset, updateAsset } from 'actions/assets/';
import AssetForm from 'components/Assets/AssetForm/AssetForm';

function AssetModal() {
  const dispatch = useDispatch();
  const { data: defaultStatus } = useSelector(
    ({ defaultStatus }) => defaultStatus,
  );
  const user = useSelector(({ user }) => user);
  const modal = useSelector(({ modal }) => modal);
  const { data: tags } = useSelector(({ tag }) => tag);
  const company = useSelector(({ company }) => company);
  const { data: storages } = useSelector(({ storages }) => storages);
  const { data: categories } = useSelector(({ categories }) => categories);
  const isOpen = modal?.type === ASSET_MODAL;
  const isEditing = isOpen && modal.initialValue;
  const actionType = isEditing ? 'Update' : 'Create';
  const modalCaption = `${actionType} Inventory Asset`;
  const { initialValue } = modal;

  const unassigned = useMemo(() => {
    return tags?.find((tag) => tag.tagname === 'unassigned')?.id || '';
  }, [tags]);

  const settings = useMemo(() => {
    return {
      units: company?.other_details?.quantity_units,
      maxQuantity: company?.package_details?.max_quantity,
    };
  }, [company]);

  function onModalClose() {
    dispatch(clearModal(ASSET_MODAL));
  }

  /**
   * @param {FormData} payload
   */
  function onSubmit(payload) {
    const { company_id: companyId } = user;
    if (isEditing) {
      const { id: assetId } = initialValue || {};
      payload.append('id', assetId);
      dispatch(updateAsset(assetId, payload, companyId, false));
    } else {
      payload.append('company_id', companyId);
      dispatch(createAsset(payload, companyId));
    }
  }

  return (
    <Modal
      modalTop={5}
      modalLeft={5}
      isOpen={isOpen}
      modalWidth={90}
      onClose={onModalClose}
      caption={modalCaption}
    >
      <AssetForm
        tag={unassigned}
        onSubmit={onSubmit}
        storages={storages}
        categories={categories}
        conditions={defaultStatus}
        initialValue={initialValue}
        onModalClose={onModalClose}
        quantityUnits={settings.units}
        maxQuantity={settings.maxQuantity}
      />
    </Modal>
  );
}

export default AssetModal;
